import React, { useEffect } from 'react'
import { adminRoutes } from '../routes/index'
import { Header, Content, Footer } from './index'
import { useNavigate } from 'react-router-dom'

function AdminLayout() {
  const navigate = useNavigate()
  const token = window.sessionStorage.getItem('token')
  const role = window.sessionStorage.getItem('role')
  useEffect(() => {
    if (!token) {
      navigate('/login', { replace: true })
    } else if (role === 'C') {
      navigate('/login', { replace: true, state: { isCurrent: 'client' } })
    } else if (role === 'A') {
      navigate('/login', { replace: true, state: { isCurrent: 'attorney' } })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, role])
  return (
    <div className="d-flex flex-column vh-100">
      <Header />
      <Content routes={adminRoutes} />
      <Footer />
    </div>
  )
}

export default AdminLayout
